import React from 'react';
import { Link } from 'react-router-dom';
import { useLeagueSelection } from '../../hooks/useLeagueSelection';
import {getTeamLogo} from '../../static/logos/TeamLogos';
import RBALogo from '../../static/logos/RBA_logo.png';
import {ersteBL, zweiteBLSW, zweiteBLNO} from '../../static/clubList';
import './Footer.css';

const Footer = () => {
    const { leagueLevel } = useLeagueSelection();
    return (
      <footer className="footer-main">
        <div className="footer-content">
            <div className="footer-content-left">
            </div>
                    <ul className="footer-content-left">
                        <li><Link to="/ueber/struktur">CONTACT</Link></li>
                        <li><Link to="/ueber">ABOUT RBA</Link></li>
                    </ul>
                    <img src={RBALogo} alt="RBA Logo" />
                <ul className="footer-content-right">
                    <li><Link to="/impressum">IMPRESSUM</Link></li>
                    <li><Link to="/cookies">COOKIE POLICY</Link></li>
                </ul>
            <div>
                {/* Placeholder for css formating */}
            </div>
        </div>
              <div className="footer-content__bottom">
                {leagueLevel === "1" ? (
                <div className="team-logos team-logos-left">
                    {ersteBL.map((club, index) => (
                        <img
                            key={index}
                            src={getTeamLogo(club)}
                            alt={`Logo ${club}`}
                            className="team-logo"
                        />
                    ))}
                </div>
                ) : (
                <>
                    <div className="team-logos team-logos-left">
                        {zweiteBLNO.map((club, index) => (
                            <img
                                key={index}
                                src={getTeamLogo(club)}
                                alt={`Logo ${club}`}
                                className="team-logo"
                            />
                        ))}
                    </div>
                <div className="devider-SW">NORD OST</div>
                <div className="devider-NO">SÜD WEST</div>
                    <div className="team-logos team-logos-right">
                        {zweiteBLSW.map((club, index) => (
                                <img
                                    key={index}
                                    src={getTeamLogo(club)}
                                    alt={`Logo ${club}`}
                                    className="team-logo"
                                />
                            ))}
                        </div>
                    </>
                    )}
                </div>
        <div className="footer-bottom-text">
            <p>Banner-Bilder: © Herrmann Agenturfotografie</p>
            <p>© 2025 Kether OS GmbH</p>
        </div>
      </footer>
    )};

export default Footer;
